<ng-template appQuote></ng-template>
